import { Component } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import {
  LoadingController,
  ModalController,
  NavController,
  Platform,
} from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { UserType, ResponseAPI } from "src/models/user.model";
import { listLanguages, Languages } from "src/models/language.model";
import { AuthService } from "src/app/services/auth.service";
import { UtilService } from "src/app/services/util.service";
import { rgxPassword } from "src/utils/regex";
import { TypeVehicle, listTypeVehicles } from "src/models/veiculo.model";
import { PasswordValidation } from "src/utils/password.validation";
import { ActivatedRoute } from "@angular/router";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

@Component({
    selector: "app-register",
    templateUrl: "register.page.html",
    styleUrls: ["register.page.scss"],
    standalone: false
})
export class RegisterPage {
  userType = UserType;
  userSelect: number = UserType.Caller;
  formDriver: UntypedFormGroup;
  formCaller: UntypedFormGroup;
  languagesUser: { value: number; label: string }[] = listLanguages;
  typesVehicle: { value: TypeVehicle; label: string }[] = listTypeVehicles;
  date: Date;
  paramRecomendation: string;
  showDriver = true;
  showCaller = true;
  visiblePassword = false;
  constructor(
    public loadingController: LoadingController,
    public modalController: ModalController,
    public authService: AuthService,
    public utilService: UtilService,
    private platform: Platform,
    public navCtrl: NavController,
    public route: ActivatedRoute,
    public fb: UntypedFormBuilder,
  ) {
    this.route.params.subscribe((param: object) => {
      if (param.hasOwnProperty("id")) {
        this.paramRecomendation = param["id"];
      }
    });
    this.date = new Date();
    //Controls formCaller
    this.formCaller = fb.group(
      {
        nome: ["", [Validators.required, Validators.maxLength(100)]],
        sobrenome: ["", [Validators.required, Validators.maxLength(100)]],
        celular: ["", [Validators.required, Validators.maxLength(15)]],
        position: ["", [Validators.maxLength(100)]],
        nomeEstabelecimento: [
          "",
          [Validators.required, Validators.maxLength(100)],
        ],
        enderecoEstabelecimento: [
          "",
          [Validators.required, Validators.maxLength(150)],
        ],
        state: [
          "",
          [Validators.required, Validators.maxLength(150)],
        ],
        cidadeEstabelecimento: [
          "",
          [Validators.required, Validators.maxLength(150)],
        ],
        zipCode: ["", [Validators.required, Validators.maxLength(150)]],
        telefoneEstabelecimento: [
          "",
          [Validators.required, Validators.maxLength(15)],
        ],
        email: ["", [Validators.required, Validators.email]],
        senha: [
          "",
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.minLength(6),
            Validators.pattern(rgxPassword),
          ],
        ],
        confirmarsenha: [
          "",
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.minLength(6),
            Validators.pattern(rgxPassword),
          ],
        ],
        termos: [false, [Validators.requiredTrue]],
        liberado: [true],
      },
      {
        validators: PasswordValidation.MatchPassword,
      }
    );

    //Controls formDriver
    this.formDriver = fb.group(
      {
        nome: ["", [Validators.required, Validators.maxLength(100)]],
        sobrenome: ["", [Validators.required, Validators.maxLength(100)]],
        celular: ["", [Validators.required, Validators.maxLength(30)]],
        documento: ["", [Validators.required, Validators.maxLength(30)]],
        idiomas: [[Languages.English], [Validators.required]],
        veiculo: fb.group({
          ano: ["", [Validators.required]],
          marca: ["", [Validators.required]],
          modelo: ["", [Validators.required]],
          placa: ["", [Validators.required]],
          cor: ["", [Validators.required]],
          tipoVeiculo: [0, [Validators.required]],
        }),
        email: ["", [Validators.required, Validators.email]],
        senha: [
          "",
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.minLength(6),
            Validators.pattern(rgxPassword),
          ],
        ],
        confirmarsenha: [
          "",
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.minLength(6),
            Validators.pattern(rgxPassword),
          ],
        ],
        termos: [false, [Validators.requiredTrue]],
      },
      {
        validators: PasswordValidation.MatchPassword,
      }
    );
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingController.create(loadingProps);
    return await loading.present();
  }

  openTerms() {
    Browser.open({
      url: "https://www.gospread.site/home/privacy",
      windowName: "_system"
    }).catch(console.error);
  }

  registerUser(userType: UserType) {
    if (userType === UserType.Caller) {
      this.formCaller.value.nome = `${this.formCaller.value.nome} ${this.formCaller.value.sobrenome}`;
      this.callRegister(this.formCaller.value, UserType.Caller);
    } else {
      this.formDriver.patchValue({
        veiculo: {
          ano: this.date.getFullYear(),
        },
      });
      this.formDriver.value.nome = `${this.formDriver.value.nome} ${this.formDriver.value.sobrenome}`;
      this.callRegister(this.formDriver.value, UserType.Driver);
    }
  }
  formatYear(event) {
    this.date = new Date(event.detail.value);
  }
  callRegister(values, typeUser: UserType) {
    this.showLoading();

    if (this.paramRecomendation) {
      values["hash-indicacao"] = this.paramRecomendation;
    }

    this.authService.registerUser(values, typeUser).subscribe(
      (response: ResponseAPI) => {
        if (response.success) {
          this.utilService.showToast(
            "Your account has been created. You will receive a text message as soon as your access is activated."
          );
          setTimeout(() => {
            this.navCtrl.navigateRoot("/");
          }, 2000);
          this.formDriver.reset();
          this.formCaller.reset();
        } else {
          response.errors.forEach((error) => {
            this.utilService.showToast(error);
          });
          this.formDriver.patchValue({
            veiculo: {
              ano: this.date.toISOString(),
            },
          });
        }

        this.loadingController.dismiss();
      },
      (error) => {
        this.formDriver.patchValue({
          veiculo: {
            ano: this.date.toISOString(),
          },
        });
        this.loadingController.dismiss();
        this.utilService.showToast("Error in registration");
      }
    );
  }

  checkValue(language): boolean {
    return language.value === Languages.English ? true : false;
  }

  async ionViewWillEnter() {
    if (Capacitor.isNativePlatform()) {
      try {
        const info = await App.getInfo();
        const packageName = info.id;
        switch (packageName) {
          case "gospread.tech.app":
            this.showDriver = false;
            this.showCaller = true;
            this.userSelect = this.userType.Caller;
            break;
          case "gospread.partners.tech.app":
            this.showCaller = false;
            this.showDriver = true;
            this.userSelect = this.userType.Driver;
            break;
          default:
            this.showCaller = true;
            this.showDriver = true;
            break;
        }
      } catch (e) {
        this.showCaller = true;
        this.showDriver = true;
      }
    }
  }
}
